import styled from 'styled-components'

import Button from '../../../components/display/Button'
import Container from '../../../components/layout/Container'
import { Section } from '../../../components/display/Landing'
import Avatar from '../../../components/display/Avatar'
import LazyImage from '../../../components/display/LazyImage'
import { Subtitle } from './shared'
import { SubSection } from '../../listing/Sections/shared'

const Wrapper = styled.div`
  text-align: center;
  ${Avatar} {
    display: inline-block;
    width: 160px;
    height: 160px;
    margin: 0;
    margin-bottom: 40px;
  }
`

const BookingButton = styled(Button)`
  display: inline-block;
  width: 100%;

  @media (min-width: 768px) {
    width: auto;
  }
`

export default ({ story, onBookingButtonClick }) => (
  <Section centered sand>
    <Container>
      <Wrapper>
        <Avatar>
          <LazyImage data-src={story.data.user.avatar} preload />
        </Avatar>
      </Wrapper>
      <Subtitle lessMargin>Book Our Adventure</Subtitle>
      <SubSection intro lessMargin>
        <p style={{ maxWidth: 600 }}>
          Book through this story to receive our itinerary and extra tips to
          help you live your adventure to the fullest.
        </p>
      </SubSection>

      <BookingButton onClick={onBookingButtonClick}>
        Book {story.data.featured_listing.listing.title}
      </BookingButton>
    </Container>
  </Section>
)
